import { openBlock as t, createElementBlock as o, createElementVNode as e } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 16"
}, n = /* @__PURE__ */ e("path", {
  stroke: "currentColor",
  "stroke-width": "1.5",
  d: "M20.544 7.045c.304.426.456.64.456.955 0 .316-.152.529-.456.955C19.178 10.871 15.689 15 11 15c-4.69 0-8.178-4.13-9.544-6.045C1.152 8.529 1 8.315 1 8c0-.316.152-.529.456-.955C2.822 5.129 6.311 1 11 1c4.69 0 8.178 4.13 9.544 6.045Z"
}, null, -1), c = /* @__PURE__ */ e("path", {
  stroke: "currentColor",
  "stroke-width": "1.5",
  d: "M14 8a3 3 0 1 0-6 0 3 3 0 0 0 6 0Z"
}, null, -1), s = [
  n,
  c
];
function l(d, h) {
  return t(), o("svg", r, [...s]);
}
const _ = { render: l };
export {
  _ as default,
  l as render
};
